import React from 'react';

import InstructionCoverBase from './InstructionCoverBase';

export const InstructionCoverDesktop = props => <InstructionCoverBase device="desktop" {...props} />;

export const InstructionCoverMobile = props => <InstructionCoverBase device="mobile" {...props} />;
